export const ophthalmologyConst = {
  path: "/single-programs/ophthalmology",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ОФТАЛЬМОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Офтальмология — профессия, через которую люди смотрят на мир</h2>
      <p>
        Офтальмология — это высокотехнологичное направление медицины, которое занимается изучением зрительной системы человека,
        диагностикой, лечением и профилактикой заболеваний глаз.
      </p>
      <p>
        Это одна из самых динамічно развивающихся отраслей, где сочетаются наука, мікрохирургия, лазерные технологии и клинический опыт.
      </p>
      <p>
        Обучение по направлению «Офтальмология» в МЕУ строится на балансе академических знаний, практических навыков и современных цифровых
        методик. Это обучение не только «про зрение» — это про якість жизни, которую вы можете вернуть своим будущим пациентам.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Анатомию и физиологию органа зрения</li>
        <li>Заболевания роговицы, хрусталика, сетчатки</li>
        <li>Лазерную и микрохирургическую офтальмологию</li>
        <li>Диагностические методы: офтальмоскопия, тонометрия, биомикроскопия</li>
        <li>Медицинскую оптику и подбор коррекционных средств</li>
        <li>Заболевания глаз у детей и возрастные изменения зрения</li>
        <li>Неотложные состояния в офтальмологии</li>
        <li>Стандарты лечения по европейским протоколам</li>
      </ul>
      <p>
        <strong>
          Учебный план включает практику в офтальмологических клиниках, мастер-классы от ведущих специалистов и участие в международных
          форумах по медицинским технологиям.
        </strong>
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Врачом-офтальмологом в частных и государственных клиниках</li>
        <li>Хирургом-офтальмологом (при соответствующей специализации)</li>
        <li>Специалистом по лазерной коррекции зрения</li>
        <li>Детским офтальмологом</li>
        <li>Медицинским экспертом в сфере производства и контроля офтальмологических препаратов и оборудования</li>
        <li>Консультантом в салонах оптики, исследователем, преподавателем</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>от <strong>€70,000 до €130,000 в год</strong></p>
      <p>
        Офтальмология — это престижная, высокооплачиваемая и стабильно востребованная медицинская спеціальність. Особенно ценятся
        специалисты с международной квалификацией и знанием современных методов лечения.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, признанный в ЕС и за его пределами</li>
        <li>Гибкая форма обучения: очно или дистанционно</li>
        <li>Доступ к современным симуляторам и VR-технологиям</li>
        <li>Возможность стажировок в офтальмологических клиниках Европы</li>
        <li>Обучение на русском или английском языке</li>
        <li>Индивидуальное сопровождение на всех этапах обучения</li>
      </ul>
      <h2>Офтальмология — точность, внимание, миссия</h2>
      <p>
        Хорошее зрение — это то, что часто воспринимается как должное. Но именно офтальмологи возвращают людям возможность видеть, жить
        полноценно и радоваться миру.
      </p>
      <br />
      <p className="padding-left">«Мы обучаем будущих врачей, которые будут возвращать свет в жизни тысяч пациентов.»</p>
      <h2>Как поступить?</h2>
      <p>
        Подайте онлайн-заявку, прикрепите документы и получите консультацию от приёмной комиссии. Мы сопроводим вас на каждом этапе
        поступления.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Офтальмология — профессия, через которую люди смотрят на мир
    Офтальмология — это высокотехнологичное направление медицины, которое занимается изучением зрительной системы человека, диагностикой, лечением и профилактикой заболеваний глаз.
    Это одна из самых динамічно развивающихся отраслей, где сочетаются наука, мікрохирургия, лазерные технологии и клинический опыт.
    Обучение по направлению «Офтальмология» в МЕУ строится на балансе академических знаний, практических навыков и современных цифровых методик. Это обучение не только «про зрение» — это про якість жизни, которую вы можете вернуть своим будущим пациентам.
    Что вы будете изучать?
    Анатомию и физиологию органа зрения
    Заболевания роговицы, хрусталика, сетчатки
    Лазерную и микрохирургическую офтальмологию
    Диагностические методы: офтальмоскопия, тонометрия, биомикроскопия
    Медицинскую оптику и подбор коррекционных средств
    Заболевания глаз у детей и возрастные изменения зрения
    Неотложные состояния в офтальмологии
    Стандарты лечения по европейским протоколам
    Учебный план включает практику в офтальмологических клиниках, мастер-классы от ведущих специалистов и участие в международных форумах по медицинским технологиям.

    Кем можно работать после окончания?
    Врачом-офтальмологом в частных и государственных клиниках
    Хирургом-офтальмологом (при соответствующей специализации)
    Специалистом по лазерной коррекции зрения
    Детским офтальмологом
    Медицинским экспертом в сфере производства и контроля офтальмологических препаратов и оборудования
    Консультантом в салонах оптики, исследователем, преподавателем
    Зарплата в Европе:
    от €70,000 до €130,000 в год
    Офтальмология — это престижная, высокооплачиваемая и стабильно востребованная медицинская спеціальність. Особенно ценятся специалисты с международной квалификацией и знанием современных методов лечения.

    Почему выбирают нас?
    Европейский диплом, признанный в ЕС и за его пределами
    Гибкая форма обучения: очно или дистанционно
    Доступ к современным симуляторам и VR-технологиям
    Возможность стажировок в офтальмологических клиниках Европы
    Обучение на русском или английском языке
    Индивидуальное сопровождение на всех этапах обучения

    Офтальмология — точность, внимание, миссия
    Хорошее зрение — это то, что часто воспринимается как должное. Но именно офтальмологи возвращают людям возможность видеть, жить полноценно и радоваться миру.
    «Мы обучаем будущих врачей, которые будут возвращать свет в жизни тысяч пациентов.»

    Как поступить?

    Подайте онлайн-заявку, прикрепите документы и получите консультацию от приёмной комиссии. Мы сопроводим вас на каждом этапе поступления.
  `,
};
